<!--
******************************
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
******************************
-->
<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="itemsPerPage"
        dense
        no-data-text="Información no disponible"
        fixed-header
        hide-default-footer
    >
        <template v-slot:[`item.fecha`]="{ item }">
            {{ $utilFront.formatDateTime(item.fecha) }}
        </template>
    </v-data-table>
  </div>
</template>
<script>
import { headersSync } from '../../../core/HeadersTable';
export default {
  name: "SyncTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    update: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
  },
  data: () => ({
    headers: headersSync,
  }),
};
</script>